<app-admin-dashboard>
    <div class="card">
      <p-breadcrumb 
        class="w-full breadcrumb-style" 
        [home]="breadcrumbHome"/>
  
      <div class="header-card pt-0">
        <div class="w-12 container-title">
          <h1 class="w-12 text-xl font-medium text-800 m-0">
            {{'AdminSpeciesManagement.PageTitle' | translate}}
          </h1>
        </div>
      </div>
      
      <div class="w-12 flex justify-content-end">
        <p-button 
          label="{{'AdminSpeciesManagement.CreateSpecieButton' | translate}}" 
          (onClick)="goToCreateSpecies()"
          icon="pi pi-plus"
          class="custom-text-button justify-content-end"/>
      </div>

      <div class="mt-4">
        <p-table
          [value]="species"
          [rowsPerPageOptions]="[10, 25, 50]"
          [loading]="loading"
          [globalFilterFields]="['id', 'name']"
          [paginator]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          class="custom-table bg-header mt-4"
          >
          <ng-template pTemplate="header">
              <tr>
                  <th>
                      <div class="flex justify-content-center align-items-center pl-space-table">
                          {{'AdminSpeciesManagement.Table.IdColumn' | translate}}
                          <p-columnFilter type="text" field="id" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"></p-columnFilter>
                      </div>
                  </th>
                  <th>
                      <div class="flex align-items-center">
                          {{'AdminSpeciesManagement.Table.NameColumn' | translate}}
                          <p-columnFilter 
                            type="text" 
                            [field]="profile?.lang === 'en' ? 'name' : 'nameEs'" 
                            display="menu" 
                            [showAddButton]="false" 
                            [showMatchModes]="false" 
                            [showOperator]="false" 
                            matchMode="contains"></p-columnFilter>
                      </div>
                  </th>
                  <th>
                      <div class="flex align-items-center">
                          {{'AdminSpeciesManagement.Table.IconColumn' | translate}}
                      </div>
                  </th>
                  <th>
                      <div class="flex justify-content-center align-items-center pr-space-table">
                          {{'AdminSpeciesManagement.Table.ActionsColumn' | translate}}
                      </div>
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-specie>
              <tr>
                  <td>
                      <div class="flex justify-content-center align-items-center pl-space-table">
                          <span>{{specie.id}}</span>
                      </div>
                  </td>
                  <td>
                      <div class="flex align-items-center">
                          <span>{{specie | speciesName}}</span>
                      </div>
                  </td>
                  <td>
                      <div class="flex align-items-center">
                          <img 
                            class="align-items-center align-content-center text-gray-500 border-round" 
                            [src]="specie.imageUrl | speciesImageUrl" 
                            alt="{{'AdminSpeciesManagement.Table.ImageNotAvailableText' | translate}}" 
                            height="50px">
                      </div>
                  </td>
                  <td>
                      <div class="flex justify-content-center align-items-center gap-1 pr-space-table">
                          <p-button 
                            icon="pi pi-pencil" 
                            label="{{'AdminSpeciesManagement.Table.EditButton' | translate}}"
                            (onClick)="goToEditSpecies(specie.id)"
                            class="custom-text-button"/>
                      </div>
                  </td>
              </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
</app-admin-dashboard>
